export default function getInitialState() {
  return {
    muteIndication: false
  };
}
